import React, {useState,useEffect} from 'react'
import MonthlyCompliance from './monthlyCompliance'
import AvrgMonthlyCompliance from './avrgMonthlyCompliance'
import api from '../../../Services/api';
import Snackbar from '@mui/material/Snackbar';
import SnackbarContent from '@mui/material/SnackbarContent';




export default function Index() {
  let data1 = sessionStorage.getItem('user');
  let corporateData = JSON.parse(data1);
  let id = corporateData.id;


  useEffect(() => {
    const timer = setTimeout(() => {
      fetchClients(id);
    }, 1000); 
  
    return () => clearTimeout(timer); 
  }, [id]);
  

  const [clients,setClients] = useState([]);
    const[loading,setLoading] = useState(true);
       const [snackbarOpen, setSnackbarOpen] = useState(false);
              const [snackbarMessage, setSnackbarMessage] = useState('');
              const [errorSnackbarOpen, setErrorSnackbarOpen] = useState(false);
              const [snackbarErrorMessage, setSnackbarErrorMessage] = useState('');
    

  const fetchClients = async () => {
    try {
    const response = await api.Corporate.getClientByCorporateId(id);
 
    if(response.status === 200){
    setClients(response.data.data || []);
    setLoading(false)
    }
    else if(response.status === 404)
    {
      setErrorSnackbarOpen(true)
            setSnackbarErrorMessage(response.data.message);
        setClients([])
        setLoading(false)
    }
    else if(response.status === 400){
      setErrorSnackbarOpen(true)
            setSnackbarErrorMessage(response.data.message);
        setClients([])
        setLoading(false)
    }
    else{
      setErrorSnackbarOpen(true)
      setSnackbarErrorMessage(response.data.message);
        setClients([])
        setLoading(false)
    }
}
catch(error){
    console.error("Error in fetching the data",error);
     setClients([])
}
finally {
  setLoading(false); 
}
}

  return (
    <>
     <Snackbar
                    anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                    severity="success"
                    open={snackbarOpen}
                    autoHideDuration={3000}
                    onClose={() => setSnackbarOpen(false)}
                    sx={{ marginTop: '2.9%', marginRight: '7%' }}
                  >
                    <SnackbarContent style={{ backgroundColor: "green" }} message={snackbarMessage} />
                  </Snackbar>
                  <Snackbar
                    anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                    severity="error"
                    open={errorSnackbarOpen}
                    autoHideDuration={3000}
                    sx={{ marginTop: '2.9%', marginRight: '7%' }}
                    onClose={() => setErrorSnackbarOpen(false)}
                  >
                    <SnackbarContent style={{ backgroundColor: "red" }} message={snackbarErrorMessage} />
                  </Snackbar>
   {loading ? (
                  <div className="d-flex flex-row align-items-center justify-content-center" style={{ marginTop: '80px' }}>
                  <h3>Loading</h3>
         <div className="spinner-grow text-danger" style={{ width: '1rem', height: '1rem' ,marginLeft:'10px'}} role="status"></div> 
         <div className="spinner-grow text-danger" style={{ width: '1rem', height: '1rem' ,marginLeft:'10px'}} role="status"></div>
         <div className="spinner-grow text-danger" style={{ width: '1rem', height: '1rem' ,marginLeft:'10px'}} role="status"></div>
         
         </div>
              ) : 
              clients.length > 0 ? (
    <div style={{display:'grid'}}>
      <div className="mt-4 mx-4" style={{ letterSpacing: '1px' }}>
              
               <div style={{ backgroundColor:'#50c878', width: '15px', height: '15px', display: 'inline-block', marginRight: '4px', borderRadius: '50%' }}></div>
               <span style={{ fontSize: '14px' }}>Accepted</span>
               <div className="vr mx-3"></div>
               <div style={{ backgroundColor:'#B22222', width: '15px', height: '15px', display: 'inline-block', marginRight: '4px', borderRadius: '50%' }}></div>
               <span style={{ fontSize: '14px' }}>Rejected</span>
                 <div className="vr mx-3"></div>
                 <div style={{ backgroundColor:'#EFCC00', width: '15px', height: '15px', display: 'inline-block', marginRight: '4px', marginLeft: '8px', borderRadius: '50%' }}></div>
               <span style={{ fontSize: '14px' }}>Under review</span>
               <div className="vr  mx-3"></div>
               <div style={{ backgroundColor:'lightgray', width: '15px', height: '15px', display: 'inline-block', marginRight: '4px', borderRadius: '50%' }}></div>
               <span style={{ fontSize: '14px' }}>Not Uploaded</span>
             </div>

    <AvrgMonthlyCompliance />
 
  
   <MonthlyCompliance/>
    </div>

              ) : <>
              <p className='text-center p-5 text-danger'>No Client Found!!</p>
              </>
            }
    </>
  )
}


